import classNames from "classnames";
import React from "react";
import styles from "./TextComponent.module.scss";

const Heading1 = (props: any) => {
  return (
    <h1
      className={classNames(styles.heading1, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h1>
  );
};
const Heading2 = (props: any) => {
  return (
    <h2
      className={classNames(styles.heading2, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h2>
  );
};
const Heading3 = (props: any) => {
  return (
    <h3
      className={classNames(styles.heading3, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h3>
  );
};
const Heading5 = (props: any) => {
  return (
    <h5
      className={classNames(styles.heading5, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h5>
  );
};
const Body1 = (props: any) => {
  return (
    <p
      className={classNames(styles.body1, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </p>
  );
};
const Body2 = (props: any) => {
  return (
    <p
      className={classNames(styles.body2, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </p>
  );
};
const Body3 = (props: any) => {
  return (
    <p
      className={classNames(styles.body3, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </p>
  );
};

const TopMenu = (props: any) => {
  return (
    <h4
      className={classNames(styles.topMenu, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h4>
  );
};
const MainMenu = (props: any) => {
  return (
    <h2
      className={classNames(styles.mainMenu, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h2>
  );
};
const ExtraMenu = (props: any) => {
  return (
    <h3
      className={classNames(styles.extraMenu, props.className, {
        [styles.centered]: props.centered,
      })}
    >
      {props.children}
    </h3>
  );
};

export {
  Heading1,
  Heading2,
  Heading3,
  Heading5,
  Body1,
  Body2,
  Body3,
  TopMenu,
  MainMenu,
  ExtraMenu,
};
